import clsx from "clsx";
import { ReactNode, useState } from "react";
import { motion } from "framer-motion";

interface Props {
  title: string;
  defaultIcon: ReactNode;
  activeIcon?: ReactNode;
  showGroup?: boolean;
  groups?: ReactNode;
  onClick?: () => void;
  showDivider: boolean;
  active?: boolean;
}
export default function DropSection(props: Props) {
  const [active, setActive] = useState(false);

  const handleClick = () => {
    if (props.groups) {
      setActive(!active);
      return;
    }
    props.onClick && props.onClick();
  };
  return (
    <>
      <div
        className={clsx(
          "flex cursor-pointer items-center justify-between py-4",
          props.active ? "text-primary" : "text-[#0E0E0E]"
        )}
        onClick={handleClick}
      >
        <label>{props.title}</label>
        <motion.div
          className="flex"
          animate={{ rotate: active ? 90 : 0 }}
          transition={{ type: "tween" }}
        >
          {props.defaultIcon}
        </motion.div>
      </div>

      {props.showDivider && <div className="h-[1px] w-full bg-F6F7F9"></div>}

      {props.groups && active && (
        <motion.div
          initial={{ display: "none" }}
          animate={{ display: active ? "block" : "none" }}
          transition={{ type: "tween" }}
        >
          {props.groups}
        </motion.div>
      )}
    </>
  );
}
